export const queryKeys = {
  auth: ['auth'] as const,
  betaAllowlist: ['admin', 'beta-allowlist'] as const,
  adminAdvices: ['admin', 'advices'] as const,
  adminAdviceCategories: ['admin', 'advice-categories'] as const,
  usersRecent: ['admin', 'users', 'recent'] as const,
  userSearch: (term: string) => ['admin', 'users', term] as const,
  userPhysio: (userId?: string) => ['admin', 'physio', userId] as const,
  trainingPlans: ['admin', 'training-plans'] as const,
  trainingPlan: (uuid?: string) => ['admin', 'training-plan', uuid] as const,
  videos: ['admin', 'videos'] as const,
  stripePlans: ['admin', 'stripe', 'plans'] as const,
  stripeProducts: ['admin', 'stripe', 'products-with-prices'] as const,
  stripeActivePrice: ['admin', 'stripe', 'active-price'] as const,
  stripeOverview: ['admin', 'stripe', 'overview'] as const,
  stripeRevenueTrend: (period: string) => ['admin', 'stripe', 'revenue-trend', period] as const,
  analyticsActiveUsers: ['admin', 'analytics', 'active-users'] as const,
  analyticsRegisteredUsers: ['admin', 'analytics', 'registered-users'] as const,
  analyticsRetention: ['admin', 'analytics', 'retention'] as const,
  analyticsNewVsReturning: ['admin', 'analytics', 'new-vs-returning'] as const,
  analyticsTopEvents: ['admin', 'analytics', 'top-events'] as const,
  analyticsFeatureAdoption: ['admin', 'analytics', 'feature-adoption'] as const,
  analyticsActivationFunnel: ['admin', 'analytics', 'activation-funnel'] as const,
  analyticsCohorts: ['admin', 'analytics', 'cohorts'] as const,
  pv2Sports: ['admin', 'pv2', 'sports'] as const,
  pv2ThemesRef: ['admin', 'pv2', 'themes-ref'] as const,
  pv2Zones: (filters: { search?: string; sport?: string }) => ['admin', 'pv2', 'zones', filters] as const,
  pv2Themes: (filters: { search?: string; page: number }) => ['admin', 'pv2', 'themes', filters] as const,
  pv2Guidance: (filters: { search?: string; sport?: string; page: number }) =>
    ['admin', 'pv2', 'guidance', filters] as const,
  pv2CompetitionGuidance: ['admin', 'pv2', 'guidance', 'competition'] as const,
  pv2Workouts: (filters: { search?: string; themeIds?: string[]; sportIds?: string[]; testsOnly?: boolean; page: number }) =>
    ['admin', 'pv2', 'workouts', filters] as const,
  pv2WorkoutKpis: ['admin', 'pv2', 'workout-kpis'] as const,
  pv2Workout: (id: string) => ['admin', 'pv2', 'workout', id] as const,
  pv2Formats: ['admin', 'pv2', 'formats'] as const,
  pv2RaceTypes: ['admin', 'pv2', 'race-types'] as const,
  pv2Cycles: (filters: { search?: string; filter?: string; page: number }) =>
    ['admin', 'pv2', 'cycles', filters] as const,
  pv2CycleKpis: ['admin', 'pv2', 'cycle-kpis'] as const,
  pv2Cycle: (id: string) => ['admin', 'pv2', 'cycle', id] as const,
  pv2CycleSessions: (id: string) => ['admin', 'pv2', 'cycle-sessions', id] as const,
  pv2CycleUsage: (id: string) => ['admin', 'pv2', 'cycle-usage', id] as const,
  pv2Plans: (filters: { search?: string; format?: string; planType?: string; page: number }) =>
    ['admin', 'pv2', 'plans', filters] as const,
  pv2PlanKpis: ['admin', 'pv2', 'plan-kpis'] as const,
  pv2Plan: (id: string) => ['admin', 'pv2', 'plan', id] as const,
  pv2PlanGenerationCheck: (id: string) => ['admin', 'pv2', 'plan-generation-check', id] as const,
  pv2PlanFormats: ['admin', 'pv2', 'plan-formats'] as const,
  pv2DateBounds: (planId: string, today: string, recoveryEndsOn?: string) =>
    ['admin', 'pv2', 'date-bounds', planId, today, recoveryEndsOn ?? null] as const,
  pv2SettingsForm: (planId: string) => ['admin', 'pv2', 'settings-form', planId] as const,
  pv2Scaling: (filters: { theme?: string; sport?: string; format?: string; page: number }) =>
    ['admin', 'pv2', 'scaling', filters] as const,
  migrationMapping: ['admin', 'migration', 'mapping'] as const,
  migrationApplyStatus: ['admin', 'migration', 'apply', 'status'] as const,
};
